<template>
  <div class="container-fluid py-3 ffd12-settings">
    <h1>ККТ ФФД 1.2</h1>
    <p class="text-muted">
      Группы Orange Data, для которых чеки формируются в формате ФФД 1.2.
      Введите название и нажмите Enter. Для удаления нажмите крестик на теге.
    </p>

    <div class="card mb-4">
      <div class="card-header">Группы ККТ</div>
      <div class="card-body">
        <div class="ffd12-tags mb-3">
          <span v-for="group in groups" :key="group" class="ffd12-tag">
            {{ group }}
            <button
              type="button"
              class="ffd12-tag-remove"
              :disabled="saving"
              :aria-label="`Удалить ${group}`"
              @click="removeGroup(group)"
            >&times;</button>
          </span>
        </div>

        <div class="input-group">
          <input
            v-model.trim="newGroup"
            type="text"
            class="form-control"
            :disabled="saving"
            placeholder="Введите receipt_group, например msk24"
            maxlength="64"
            @keyup.enter="addGroup"
          >
          <div class="input-group-append">
            <button class="btn btn-primary" type="button" :disabled="saving || !newGroup" @click="addGroup">
              Добавить
            </button>
          </div>
        </div>
        <small class="form-text text-muted">Допустимы латинские буквы, цифры, дефис и подчёркивание.</small>
      </div>
    </div>

    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span>История изменений</span>
        <select v-model.number="perPage" class="custom-select custom-select-sm page-size" @change="changePageSize">
          <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
        </select>
      </div>

      <el-table :data="logs.data || []" stripe>
        <el-table-column prop="created_at" label="Дата" min-width="170"/>
        <el-table-column prop="group_name" label="Группа ККТ" min-width="150"/>
        <el-table-column label="Действие" min-width="130">
          <template slot-scope="scope">
            <span :class="['badge', scope.row.action === 'added' ? 'badge-success' : 'badge-danger']">
              {{ scope.row.action === 'added' ? 'Добавлена' : 'Удалена' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Пользователь" min-width="240">
          <template slot-scope="scope">
            {{ userLabel(scope.row) }}
          </template>
        </el-table-column>
      </el-table>

      <div v-if="loading" class="p-3 text-center text-muted">Загрузка…</div>
      <div v-if="logs.total" class="d-flex align-items-center justify-content-between p-3">
        <span>Всего: {{ logs.total }}</span>
        <div class="btn-group">
          <button class="btn btn-outline-secondary btn-sm" :disabled="logs.current_page <= 1" @click="load(logs.current_page - 1)">
            Назад
          </button>
          <span class="btn btn-light btn-sm disabled">{{ logs.current_page }} / {{ logs.last_page }}</span>
          <button class="btn btn-outline-secondary btn-sm" :disabled="logs.current_page >= logs.last_page" @click="load(logs.current_page + 1)">
            Вперёд
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '../../api'

  export default {
    metaInfo: {title: 'ККТ ФФД 1.2'},
    data () {
      return {
        groups: [],
        newGroup: '',
        logs: {},
        pageSizes: [25, 50, 100, 500, 1000],
        perPage: 25,
        loading: false,
        saving: false,
      }
    },
    created () {
      this.load(1)
    },
    methods: {
      load (page = 1) {
        this.loading = true
        return api.get('ffd12-receipt-groups', {params: {page, per_page: this.perPage}})
          .then(response => {
            this.groups = response.data.groups
            this.logs = response.data.logs
            this.pageSizes = response.data.page_sizes
          })
          .finally(() => {
            this.loading = false
          })
      },
      addGroup () {
        const group = this.newGroup.toLowerCase()
        if (!group || this.saving) return
        this.save(api.post('ffd12-receipt-groups', {name: group}))
      },
      removeGroup (group) {
        if (this.saving) return
        this.save(api.delete(`ffd12-receipt-groups/${encodeURIComponent(group)}`))
      },
      save (request) {
        this.saving = true
        request
          .then(() => {
            this.newGroup = ''
            return this.load(1)
          })
          .catch(error => {
            const errors = error.response && error.response.data && error.response.data.errors
            const errorKey = errors ? Object.keys(errors)[0] : null
            const message = errorKey ? errors[errorKey][0] : 'Не удалось сохранить изменение'
            this.$root.showAlert(message)
          })
          .finally(() => {
            this.saving = false
          })
      },
      changePageSize () {
        this.load(1)
      },
      userLabel (log) {
        if (!log.user) return log.user_email || '—'
        const name = [log.user.second_name, log.user.first_name, log.user.third_name].filter(Boolean).join(' ')
        return name ? `${name} (${log.user_email})` : log.user_email
      },
    },
  }
</script>

<style scoped>
  .ffd12-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    min-height: 2rem;
  }
  .ffd12-tag {
    display: inline-flex;
    align-items: center;
    padding: 0.3rem 0.35rem 0.3rem 0.65rem;
    border: 1px solid #b8d8e8;
    border-radius: 0.25rem;
    background: #eef7fb;
    color: #27647f;
    line-height: 1;
  }
  .ffd12-tag-remove {
    margin-left: 0.35rem;
    padding: 0 0.2rem;
    border: 0;
    background: transparent;
    color: #6c9caf;
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
  }
  .ffd12-tag-remove:hover {
    color: #dc3545;
  }
  .page-size {
    width: 100px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/ffd12-receipt-groups.vue